import React from 'react';
import './DeleteContactsForm.scss';
import { closeDeleteGroupContactsForm } from './contactsSlice';
import { deleteGroupContact } from '../../Authorization/authSlice';

const DeleteGroupContactsForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 
 const onSend = () => {
      
    console.log('Start delete group contact action');

        const data = {
            
            groupId: props.groupId,
        }

        dispatch(deleteGroupContact(data));
       
    
       dispatch(closeDeleteGroupContactsForm());
    }
    
    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeDeleteGroupContactsForm());
    

    }


    const render = () => {
        //console.log(this.props.adminState.openInputForms);
       // this.props.accountState.openClearHistoryForm)
        
            return(
                <div className="DeleteContactsForm">
                    
                <p><b>Вы действительно хотите удалить группу?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
       
   
    }
return render();
}
export default DeleteGroupContactsForm;
  